import React from 'react';
import styled from '@emotion/styled';
import { Box, Typography, TypographyProps } from '@mui/material';
import { colors } from 'theme/colors';

const StyledTypography = styled(Typography)`
  background-color: ${colors.primary15};
  color: ${colors.primary900};
  font-size: 20px;
  font-weight: 400;
`;

const StyledContainer = styled(Box)`
  height: 48px;
  min-width: 100%;
  padding-left: 20px;
  padding-top: 10px;
  margin-bottom: 16px;
  background-color: ${colors.primary15};
`;

type SubsectionHeaderProps = TypographyProps & {
  children?: React.ReactNode;
};

const SubsectionHeader = ({ children, ...typeProps }: SubsectionHeaderProps) => (
  <StyledContainer>
    <StyledTypography {...typeProps}>{children}</StyledTypography>
  </StyledContainer>
);

export { SubsectionHeader };
